// extracted by mini-css-extract-plugin
module.exports = {"body":"_fe7bb78","button":"_cbe1b1b"};